module.exports = __webpack_public_path__ + "img/medical_medicine_internal.b69d8f41.jpg";